import Vue from 'vue'

const rappresentante_fields = ['cognome','nome']

Vue.prototype.$az = {

  getRappresentanteFullname(azienda) {
    if (azienda.tipo_azienda === "DITTA IND.") {
      return `${azienda.ind_nome} ${azienda.ind_cognome}`;
    } else {
      const rappresentanteContatto = azienda.contatti.find(
        (c) => c.id_ruolo === 93 || c.id_ruolo === 1
      );

      if (rappresentanteContatto) {
        const { cognome, nome } = rappresentanteContatto.contatto;
        return `${nome} ${cognome}`;
      } else {
        return "";
      }
    }
  },

  getRappresentanteEmail(azienda) {
    return azienda.email_dl
  },

  checkResponsabile(selected, cat) {
    let dict = {
      'Contabilità' : 'resp_contabile',
      'Privacy' : 'resp_privacy',
      'Redditi' : 'resp_redditi',
      'Paghe' : 'resp_paghe',
      'Haccp' : 'resp_hccp',
      'Fiscale' : 'resp_consulente',
      'Sicurezza' : 'resp_sicurezza',
    }
    let x = null
    if (dict[cat]) {
      x = selected[dict[cat]]
    }
    return x ? x.nome : ''
    // cat = cat == 'Contabilità' ? 'Contabilita' : cat
    // if (cat == 'Haccp') {
    //   let x = selected.resp_hccp
    //   return x ? x.nome : ''
    // }
    //
    // let str = null
    // if (selected_resp.length) {
    //   str = selected_resp.find( resp => {
    //     let rs = resp.ufficio ? resp.ufficio.slice(0,cat.length) : '' // if wanted "Paghe 1" => "Paghe", use "rs" instead of "resp.ufficio"
    //     if (rs == cat) return resp
    //   })
    // }
    // return str ? str.nome : ""
  },

}
